<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g94hyT/tc-custom/9781453273890.jpg?1701561913778" alt="This image is the cover for the book Come Die with Me, The Brock Callahan Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Come Die with Me, The Brock Callahan Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Brock gets caught in a dangerous triangle between a jockey, a mobster, and L.A.’s finest blonde</b> Gloria Malone is a big woman with a little husband, and a problem only Brock Callahan can solve. Her jockey beau, Tip, has fallen in with a half-reformed gangster, and Gloria fears trouble for the pint-sized horseman. But as Brock quickly finds, L.A.’s criminals have more to fear from Tip than he does from them. The short man has a long mean streak, a girl on the side, and a couple of illegitimate children to boot. Even his horses don’t like him. Brock isn’t surprised when someone decides to end the little gremlin’s racing career once and for all—with a carving knife. The world of horse racing is buried under a layer of grime that’s thicker than the Santa Anita racetrack’s mud after a thunderstorm. To penetrate it, Brock will have to take the whip into his own hand and do whatever it takes to stay on the horse.<br/><br/> Come Die With Me <i>is the 4th book in the Brock Callahan Mysteries, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Campbell Gault
      </h2>
      
      <p class="authorDescription body article">William Campbell Gault (1910&ndash;1995) was a critically acclaimed pulp novelist. Born in Milwaukee, Wisconsin, he took seven years to graduate from high school. Though he was part of a juvenile gang, he wrote poetry in his spare time, signing it with a girl&rsquo;s name lest one of his friends find it. He sold his first story in 1936, and built a great career writing for pulps like <i>Paris Nights</i>, <i>Scarlet Adventures</i>, and the infamous <i>Black Mask</i>. In 1939, Gault quit his job and started writing fulltime.&#160;When the success of his pulps began to fade in the 1950s, Gault turned to longer fiction, winning an Edgar Award for his first mystery, <i>Don&rsquo;t Cry for Me</i> (1952), which he wrote in twenty-eight days. He created private detectives Brock Callahan and Joe Puma, and also wrote juvenile sports books like <i>Cut-Rate Quarterback</i> (1977) and <i>Wild Willie, Wide Receiver</i> (1974). His final novel was <i>Dead Pigeon</i> (1992), a Brock Callahan mystery. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62358506